import {Component, OnInit} from '@angular/core';
import {Vacancy} from '../models/vacancy';
import {StateService} from '../state.service';
import {Router} from '@angular/router';
import {AppService} from '../app.service';
import {VacancyStatus} from '../models/vacancy-status.enum';
import {VacancyService} from '../vacancy.service';

@Component({
  selector: 'app-vacancy-page',
  templateUrl: './vacancy-page.component.html',
  styleUrls: ['./vacancy-page.component.css']
})
export class VacancyPageComponent implements OnInit {

  ngOnInit(): void {
  }

  constructor(private stateService: StateService, private router: Router, private appService: AppService, private vacancyService: VacancyService) {
    this.appService.pageTitle = 'Otentica - Vacancies';
  }

  public getVacancies(): Vacancy[] {
    return this.vacancyService.getAllVacancies();
  }

  public canView(): (vacancy: Vacancy) => boolean {
    let stateService: StateService = this.stateService;
    return (vacancy: Vacancy) => {
      return true;
    }
  }

  public getReadableStatus(vacancy: Vacancy): string {
    switch(vacancy.status) {
      case VacancyStatus.OPEN:
        return "Open";
      case VacancyStatus.CLOSED:
        return "Closed";
    }
  }

  public getNumCandidates(vacancy: Vacancy): number {
    return 3;
  }

  public getNumMatchingCandidates(vacancy: Vacancy): number {
    return 1;
  }

  public getNumMatchingInternals(vacancy: Vacancy): number {
    return 0;
  }

  public view(vacancy: Vacancy): void {
    this.router.navigate(['vacancy', vacancy.id]);
  }

}
